export const gettersTypes = {
  numOfAvailablePersonalTests: '[testing] number of available personal tests',
  openQuestionsProfile: '[testing] open questions profile',
  isReadyOpenQuestions: '[testing] is ready open questions',
  isReadyOpenQuestionsProfile: '[testing] is ready open questions profile',
};

const getters = {
  [gettersTypes.numOfAvailablePersonalTests]: (state) => {
    if (!state.metadataPersonalTests) return null;
    return state.metadataPersonalTests.filter((test) => test.is_available).length;
  },
  [gettersTypes.openQuestionsProfile]: (state) => {
    return (state.openQuestions || []).filter((question) => {
      return !question.block_id && !question.skill_id;
    });
  },
  [gettersTypes.isReadyOpenQuestions]: (state) => {
    return (state.openQuestions || []).every((question) =>
      question.required ? question.answer : true
    );
  },
  [gettersTypes.isReadyOpenQuestionsProfile]: (state, getters) => {
    return getters[gettersTypes.openQuestionsProfile].every((question) =>
      question.required ? question.answer : true
    );
  },
};

export default getters;
